import { Typography, Box, Tooltip, Chip } from "@mui/material";
import { ManageSearchIcon } from "../icons";
import { t } from "i18next";
import { IRenderFileChipsProps } from "@types";

export const EmptyContent = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 2,
        backgroundColor: "rgba(0, 0, 0, 0.02)",
        borderRadius: 1,
        width: "100%",
      }}
    >
      <Typography
        variant="h6"
        color="var(--text-secondary-color)"
        sx={{ mb: 1 }}
      >
        데이터가 없습니다
      </Typography>
      <Typography
        variant="body2"
        color="var(--text-secondary-color)"
        align="center"
      >
        해당 클래스에 대한 학습 이력이 존재하지 않습니다.
      </Typography>
    </Box>
  );
};

export const EmptyBox = ({ version }: { version: string }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        flex: 1,
        p: 1,
        border: "1px dashed",
        borderColor: "divider",
        backgroundColor: "action.hover",
      }}
    >
      <ManageSearchIcon
        sx={{
          fontSize: 40,
          color: "var(--text-secondary-color)",
          mb: 1.5,
          opacity: 0.7,
        }}
      />
      <Typography
        sx={{
          color: "var(--text-secondary-color)",
          textAlign: "center",
          fontSize: "0.95rem",
          fontWeight: 500,
        }}
      >
        {version === "project" ? t("NoTopAccuracyMsg") : t("NoTrainHistoryMsg")}
      </Typography>
    </Box>
  );
};

export const EmptyTemplate = (): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
        px: 2,
        backgroundColor: "rgba(0, 0, 0, 0.02)",
        borderRadius: 1,
      }}
    >
      <Typography
        variant="h6"
        color="var(--text-secondary-color)"
        sx={{ mb: 1 }}
      >
        템플릿의 항목이 존재하지 않습니다.
      </Typography>
      <Typography
        variant="body2"
        color="var(--text-secondary-color)"
        align="center"
      >
        해당 템플릿은 구성 항목이 존재하지 않는 빈 템플릿입니다.
      </Typography>
    </Box>
  );
};

export const RenderFileChips: React.FC<IRenderFileChipsProps> = ({
  files,
  icon,
  handleDelete,
}) => {
  if (files.length === 0) return null;

  const filePaths = files.map((f) => f.path);
  const firstFileName = filePaths[0].split("/");
  const namePart = firstFileName[firstFileName.length - 1];

  const displayName =
    filePaths.length > 1
      ? `${namePart} 외 ${filePaths.length - 1}장`
      : filePaths[0];

  const maxTooltipFiles = 10;
  const tooltipFiles =
    filePaths.length > maxTooltipFiles
      ? [
          ...filePaths.slice(0, maxTooltipFiles),
          `...외 ${filePaths.length - maxTooltipFiles}장`,
        ]
      : filePaths;

  return (
    <Tooltip
      title={tooltipFiles.join("\n")}
      arrow
      placement="top"
      sx={{ cursor: "pointer" }}
    >
      <Chip icon={icon} label={displayName} onDelete={handleDelete} />
    </Tooltip>
  );
};
